import { msalInstance } from "..";
import { appConfig } from "../components/AppConfig/variables";
import { handleLogout } from "../components/Auth/UserLogout";
import {
  createAccessArray,
  viewsKeyMap,
} from "../components/AuthConfig/actionMap";
import { getData } from "../components/Utilities/CommonFunc";
import {
  setAllActions,
  setAllViews,
  setAuthInfo,
  setLoader,
  setRoleInfo,
} from "../store/userStore";

export function getUserRoleInfoApi(username) {
  return (dispatch) => {
    dispatch(setLoader({ loaderKey: "roleInfo", loaderValue: true }));

    const url =
      appConfig.env[appConfig.current_env].rest_api_host +
      "/global/fetch_roles_rights?user_nm=" +
      username;

    getData(url)
      .then((res) => res.counts)
      .then((data) => {
        dispatch(setLoader({ loaderKey: "roleInfo", loaderValue: false }));

        dispatch(setRoleInfo(data));

        const allViews = data.RIGHTS.filter((x) => x.startsWith("VIEWS"));
        const allActions = data.RIGHTS.filter((x) => x.startsWith("ACTION"));
        dispatch(setAllViews(allViews));
        dispatch(setAllActions(allActions));
      })
      .catch(function (err) {
        handleLogout(msalInstance);
        console.log("Error occured fetching getLastRefreshDate !!");
        console.log(err);
      });
  };
}
